"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.classToJsonSchema = void 0;
const cv = __importStar(require("class-validator"));
const class_validator_jsonschema_1 = require("class-validator-jsonschema");
const Transformer_1 = require("../../../gal-dtos/Transformer");
const parseMetadata = (meta, options) => {
    var _a, _b, _c;
    if (typeof meta.target === 'function') {
        const typeMeta = options.classTransformerMetadataStorage
            ? options.classTransformerMetadataStorage.findTypeMetadata(meta.target, meta.propertyName)
            : null;
        const childType = typeMeta
            ? typeMeta.typeFunction()
            : getPropType(meta.target.prototype, meta.propertyName);
        let schema = targetToSchema(childType);
        if (meta.each && !typeMeta) {
            let items = { type: 'object' };
            switch (meta.type) {
                case cv.IS_STRING:
                case cv.IS_DATE_STRING:
                    items = { type: 'string' };
                    break;
                case cv.IS_BOOLEAN:
                    items = { type: 'boolean' };
                    break;
                case cv.IS_NUMBER:
                    items = { type: 'number' };
                    break;
                case cv.IS_ARRAY:
                    items = { type: 'array' };
                    break;
            }
            schema = items;
        }
        const reflectedInstance = typeMeta
            ? new typeMeta.reflectedType()
            : null;
        if (reflectedInstance &&
            Array.isArray(reflectedInstance) &&
            !meta.each) {
            const additionalConstraints = (_c = (_b = (_a = options.validationMetadatas) === null || _a === void 0 ? void 0 : _a[meta.target.name]) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c[meta.propertyName];
            schema = {
                ...additionalConstraints,
                ...schema,
                type: 'array',
            };
            delete schema.properties;
            delete schema.required;
            delete schema.items.$ref;
        }
        if (schema.$ref && !options.definitions[childType.name]) {
            options.definitions[childType.name] = (0, exports.classToJsonSchema)(childType);
        }
        return schema;
    }
};
const nestedOptions = {
    classTransformerMetadataStorage: Transformer_1.defaultMetadataStorage,
    classValidatorMetadataStorage: cv.getMetadataStorage(),
    additionalConverters: {
        [cv.IS_DATE_STRING]: parseMetadata,
        [cv.IS_DATE]: parseMetadata,
        [cv.IS_DEFINED]: parseMetadata,
        [cv.IS_BOOLEAN]: parseMetadata,
        [cv.IS_NUMBER]: parseMetadata,
        [cv.IS_STRING]: parseMetadata,
        [cv.IS_NOT_EMPTY]: parseMetadata,
        [cv.IS_ARRAY]: parseMetadata,
        [cv.ARRAY_MIN_SIZE]: parseMetadata,
        [cv.ValidationTypes.IS_DEFINED]: parseMetadata,
        [cv.ValidationTypes.NESTED_VALIDATION]: parseMetadata,
        [cv.ValidationTypes.CUSTOM_VALIDATION]: (meta, _options) => {
            if (meta.type.startsWith('BigNumber')) {
                return {
                    description: 'bignumber.js',
                    type: 'string',
                    format: 'number',
                    example: 'string<bignumber>',
                };
            }
        },
    },
};
const getPropType = (target, property) => {
    return Reflect.getMetadata('design:type', target, property);
};
const targetToSchema = (type) => {
    if (typeof type === 'function') {
        if (type.prototype === String.prototype ||
            type.prototype === Symbol.prototype) {
            return { type: 'string' };
        }
        else if (type.prototype === Number.prototype) {
            return { type: 'number' };
        }
        else if (type.prototype === Boolean.prototype) {
            return { type: 'boolean' };
        }
        const schema = (0, exports.classToJsonSchema)(type);
        return schema;
    }
};
const classToJsonSchema = (clz) => {
    const options = {
        ...nestedOptions,
        validationMetadatas: (0, class_validator_jsonschema_1.validationMetadatasToSchemas)(),
        definitions: {},
    };
    const schema = (0, class_validator_jsonschema_1.targetConstructorToSchema)(clz, options);
    schema.definitions = options.definitions;
    return schema;
};
exports.classToJsonSchema = classToJsonSchema;
